import { useParams } from 'react-router-dom'
import ModalCreateEdit from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import useLangData from '../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs, getISOCurrencyMain } from '../../../../../../utils/reducers/getters'
import { ModifiedCreateProductModelType } from '../../../../types'


interface CreateUniqueProductProps extends ModalEditComponentProps { }

const CreateUniqueProduct: React.FC<CreateUniqueProductProps> = ({ allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: allRowData?.basicData.ProductLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const params = useParams<{ id: string }>()
    const ProductId = params.id
    const fields: FormRender<ModifiedCreateProductModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang,
                    required: true
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    lang: selectedLang,
                    value: data?.['name'][selectedLang],
                    defaultValue: rest.basicData?.name || rest.basicData?.name,
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'nameLangs',
                    component: 'InputHidden',
                    value: data?.name ? JSON.stringify(data?.name) : JSON.stringify({ [selectedLang]: rest.basicData?.name })
                },
                {
                    name: 'unique_number',
                    label: t('uniqueNumber', 'Número único'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'uniqueProduct',
                    label: '',
                    component: 'InputHidden',
                    type: 'hidden',
                    value: 'true',
                },
                {
                    name: 'ProductId',
                    label: '',
                    component: 'InputHidden',
                    type: 'hidden',
                    value: ProductId,
                },
                {
                    name: 'CurrencyId',
                    label: '',
                    component: 'InputHidden',
                    value: getISOCurrencyMain(),
                }
            ]
        }
    ]
    return (<ModalCreateEdit fields={fields} url={'/api/app/product/createProduct'} translations={{
        title: t('createUniqueProduct', 'Crear producto único'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default CreateUniqueProduct